import React, { PureComponent } from 'react';

const defaultSrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNMSXwjCQAErgHM3uIwJAAAAABJRU5ErkJggg==';
export default class LazyImage extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            src: defaultSrc,
        };
        this.id;
    }
    componentDidMount() {
        window.dispatchEvent( new window.CustomEvent( 'checkImages'  ) );
    }
    render() {
        var props = { ...this.props };
        if( this.state.src == defaultSrc ) {
            props.style = {
                ...props.style,
            };
            props.alt = ' ';
        }

        return (
            <img id={ this.state.identifier } src={ this.props.source } alt={ props.alt } style={ props.style } />
        );

        // return (
        //     <img id={ this.state.identifier } src={ this.state.src } alt={ props.alt } style={ props.style } data-source={ this.props.source } data-lazy='true' ref={ (el)=>{ this._el = el; } } />
        // );
    }
}
